import { useEffect } from 'react'
import { getRevisionBasicInformation, getElementsByGAPId, getFishboneTemplateList, getGapAefFishbones, getGapAnalyzeMyActions, getGAPById, getGapRevisionDatareieList, getGapRevisionsList, getGapFull, getHomeGapStadistic, getListGapActionDocuments, getListGapActions, getListGapAnalyzeComments, getListGapAnalyzeDataseriesIds, getListGapCausesBoard, getListGapRevisionDocuments, getListGaps, getListLastActions, getListLastEvents, getPossibleGaps, getGapDataseriePossiblesGaps, getListLastEventsHome, getListLastActionsHome, getGapRevisionPossibleGaps, getGapRevisionPossibleActions, getGapAnalizeByElementId, createGapAnalyzeProcess, getActionComments } from '../../../services/sKPI/gap.service';
import { __GapEventTypes } from '../../../common/Dictionaries';
import moment from 'moment';
import { t } from 'i18next';
import { useDispatch } from 'react-redux';
import { action_setGapActions, action_setGapCauses } from '../../../reducers/actions/KPI/actions';

function TransformToFishboneStructure(arr, addIdsToText, gapValue) {
    let newArr = [];

    arr.forEach(fishbone => {

        let mainObjFishbone = {}
        mainObjFishbone["id"] = fishbone.id;
        mainObjFishbone["name"] = fishbone.name;
        mainObjFishbone["description"] = fishbone.description;
        mainObjFishbone["fishboneConceptId"] = fishbone.fishboneConceptId !== undefined ? fishbone.fishboneConceptId : fishbone.l_category.length > 0 ? fishbone.l_category[0].fishboneConceptId : null;

        mainObjFishbone.objNew = {};
        
        let aux = (gapValue !== undefined && gapValue !== null)? fishbone.name + "[#]" + gapValue : fishbone.name;

        mainObjFishbone.objNew[aux] = {};

        let categoryList = fishbone.l_category !== undefined ? fishbone.l_category : fishbone.l_gap_aef_category;

        categoryList.forEach(category => {
            mainObjFishbone.objNew[aux][category.name] = [];

            let causeList = category.l_cause !== undefined ? category.l_cause : category.l_gap_aef_cause;
            causeList.forEach(cause => {
                mainObjFishbone.objNew[aux][category.name].push(addIdsToText ? (cause.id + "[#]" + cause.name) : cause.name)
            });
        });
    
        newArr.push(mainObjFishbone);
    });
    
    return (newArr);
}

const useGetCreateGapAnalyzeProcessByElementId = (qsElementId, gapAnalyze, setGapAnalize) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await createGapAnalyzeProcess(qsElementId);

                const response = serviceResponse.data;

                if (response.succeeded) {
                    setGapAnalize && setGapAnalize(response.data);
                } else {
                    setGapAnalize && setGapAnalize({id : 0});
                }
            }
            catch (error) {
                setGapAnalize && setGapAnalize({id : 0});
            }
        }
        
        if (qsElementId !== null && gapAnalyze.id === null) {
            getData()
        }
    }, [qsElementId, gapAnalyze, setGapAnalize]);
}

const useGetGAPById = (qsGAPId, gapAnalyzeId, setGAPItem, setMessageConfig) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getGAPById(qsGAPId);
                const response = serviceResponse.data;

                if (response.succeeded) {
                    if (response.data.id !== 0 && response.data.id !== null) {
                        setGAPItem && setGAPItem(response.data);
                        
                        setMessageConfig && setMessageConfig({
                            message : null,
                            messageType : "error",
                            showMessage : false,
                        });
                    }
                    else {
                        setMessageConfig && setMessageConfig({
                            message : 'data-lang-msg-operationerror',
                            messageType : "error",
                            showMessage : true,
                        });
                    }
                } else {
                    setMessageConfig && setMessageConfig({
                        message : 'data-lang-msg-operationerror',
                        messageType : "error",
                        showMessage : true,
                    });

                    setGAPItem && setGAPItem(prevState => ({
                        ...prevState,
                        id: 0
                    }));
                }
            }
            catch (error) {
                setGAPItem && setGAPItem(prevState => ({
                    ...prevState,
                    id: 0
                }));
            }
        }
        
        if (qsGAPId !== null && qsGAPId !== undefined && gapAnalyzeId === null) {
            getData()
        }
    }, [qsGAPId, gapAnalyzeId, setGAPItem, setMessageConfig]);
}

const useGetHomeGapStadistic = (calendarSelectorId, periodId, homeStadistic, setHomeStadistic) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getHomeGapStadistic(calendarSelectorId, periodId);
                const response = serviceResponse.data;

                setHomeStadistic && setHomeStadistic((response.succeeded) ? response.data : [])     
            }
            catch (error) {
                setHomeStadistic && setHomeStadistic([])     
            }
        }
        
        if (homeStadistic === null) {
            getData()
        }
    }, [homeStadistic, calendarSelectorId, periodId, setHomeStadistic]);
}

const useGetGapRevisionsList = (gapAnalyzeId, gapRevisionsArray, setGapRevisionsArray, setGapRevisionsListFiltred, setSelectedRevision, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getGapRevisionsList(gapAnalyzeId);

                if (serviceResponse.data.succeeded) {
                    let result = serviceResponse.data;
                        setGapRevisionsArray && setGapRevisionsArray(prevState => ({
                            ...prevState,
                            fireUpdate: true,
                            data: result.data
                        }));

                        setGapRevisionsListFiltred && setGapRevisionsListFiltred(prevState => ({
                            ...prevState,
                            fireUpdate: true,
                            data: result.data
                        }));

                    if (result.data.length > 0) {
                        setSelectedRevision && setSelectedRevision(result.data[0]);
                    }
                }
                else {
                    setGapRevisionsArray && setGapRevisionsArray(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: []
                    }));

                    setGapRevisionsListFiltred && setGapRevisionsListFiltred(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: []
                    }));
                }
            }
            catch (error) {
                setGapRevisionsArray && setGapRevisionsArray(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: []
                })); 
                
                setGapRevisionsListFiltred && setGapRevisionsListFiltred(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: []
                }));
            }
        }
        
        if (gapAnalyzeId !== null && gapRevisionsArray === null && isPanelOpen === true) {
            getData()
        }

    }, [gapAnalyzeId, gapRevisionsArray, setGapRevisionsArray, setSelectedRevision, isPanelOpen]);
}

const useGetGapRevionListPossibleActions = (gapAnalyzeId, elementId, revisionId, actionsToAnalyzeArray, setActionsToAnalyzeArray, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getGapRevisionPossibleActions(gapAnalyzeId, elementId, revisionId);

                if (serviceResponse.data.succeeded) {
                    let result = serviceResponse.data;

                    result.data.forEach(possibleAction => {
                        possibleAction.checked = possibleAction.l_GapRevisionId.find(x => x === revisionId) !== undefined;
                    });

                    setActionsToAnalyzeArray && setActionsToAnalyzeArray(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: result.data
                    }));
                }
                else {
                    setActionsToAnalyzeArray && setActionsToAnalyzeArray(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: []
                    }));
                }
            }
            catch (error) {
                setActionsToAnalyzeArray && setActionsToAnalyzeArray(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: []
                }));  
            }
        }
        
        if (gapAnalyzeId !== null && actionsToAnalyzeArray === null && isPanelOpen === true) {
            getData()
        }

    }, [gapAnalyzeId, elementId, revisionId, actionsToAnalyzeArray, setActionsToAnalyzeArray, isPanelOpen]);
}

const useGetGapRevisionPossibleGaps = (gapAnalyzeId, elementId, revisionId, gapToAnalyzeArray, setGapToAnalyzeArray, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getGapRevisionPossibleGaps(gapAnalyzeId, elementId, revisionId);

                if (serviceResponse.data.succeeded) {
                    let result = serviceResponse.data;

                    result.data.forEach(possibleAction => {
                        possibleAction.checked = possibleAction.l_GapRevisionId.find(x => x === revisionId) !== undefined;
                    });

                    setGapToAnalyzeArray && setGapToAnalyzeArray(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: result.data
                    }));
                }
                else {
                    setGapToAnalyzeArray && setGapToAnalyzeArray(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: []
                    }));
                }
            }
            catch (error) {
                setGapToAnalyzeArray && setGapToAnalyzeArray(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: []
                }));  
            }
        }
        
        if (gapAnalyzeId !== null && gapToAnalyzeArray === null && isPanelOpen === true) {
            getData()
        }

    }, [gapAnalyzeId, elementId, revisionId, gapToAnalyzeArray, setGapToAnalyzeArray, isPanelOpen]);
}

const useGetGapRevisionDatareieList = (gapAnalyzeId, elemenentId, gapRevisionDataserieList, setGapRevisionDataserieList) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getGapRevisionDatareieList(gapAnalyzeId, elemenentId);

                if (serviceResponse.data.succeeded) {
                    let result = serviceResponse.data;

                    setGapRevisionDataserieList && setGapRevisionDataserieList(result.data)
                }
                else {
                    setGapRevisionDataserieList && setGapRevisionDataserieList([])   
                }
            }
            catch (error) {
                setGapRevisionDataserieList && setGapRevisionDataserieList([])   
            }
        }
        
        if (gapAnalyzeId !== null && gapRevisionDataserieList === null) {
            getData()
        }

    }, [gapAnalyzeId, elemenentId, gapRevisionDataserieList, setGapRevisionDataserieList]);
}

const useGetFishboneTemplateList = (fishboneArray, setFishboneArray, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getFishboneTemplateList();

                if (serviceResponse.data.succeeded) {
                    let manipulatedObject = TransformToFishboneStructure(serviceResponse.data.data, false);
                    setFishboneArray && setFishboneArray(manipulatedObject);
                }
                else {
                    setFishboneArray && setFishboneArray([]);
                }
            }
            catch (error) {
                setFishboneArray && setFishboneArray([]);
            }
        }
        
        if (fishboneArray === null && isPanelOpen === true) {
            getData()
        }

    }, [fishboneArray, setFishboneArray, isPanelOpen]);
}

const useGetGAPElementsByGAPId = (gapAnalyzeId, elementsArray, setElementsList, setSelectedElementId) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getElementsByGAPId(gapAnalyzeId);

                if (serviceResponse.data.succeeded) {
                    setElementsList && setElementsList(serviceResponse.data.data);
                    //setPageElementList && setPageElementList(serviceResponse.data.data);

                    if (serviceResponse.data.data.length > 0) {
                        setSelectedElementId && setSelectedElementId(serviceResponse.data.data[0].elementId);
                    }
                }
                else {
                    setElementsList && setElementsList([]);
                    //setPageElementList && setPageElementList([]);
                }
            }
            catch (error) {
                setElementsList && setElementsList([]);
                //setPageElementList && setPageElementList([]);
            }
        }
        
        if (gapAnalyzeId !== null && elementsArray === null) {
            getData()
        }

    }, [gapAnalyzeId, elementsArray, setElementsList, setSelectedElementId]);
}

const useGetListGapAnalyzeDataseriesIds = (gapAnalyzeId, elementId, revisionId, gapAnalyzeDataseriesIds, setGapAnalyzeDataseriesIds) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListGapAnalyzeDataseriesIds(gapAnalyzeId, elementId, revisionId);

                if (serviceResponse.data.succeeded) {
                    serviceResponse.data.data.unshift({  id: 0, code: null, name: 'data-lang-lbl-all' })
                    setGapAnalyzeDataseriesIds && setGapAnalyzeDataseriesIds(serviceResponse.data.data);
                }
                else {
                    setGapAnalyzeDataseriesIds && setGapAnalyzeDataseriesIds([]);
                }
            }
            catch (error) {
                setGapAnalyzeDataseriesIds && setGapAnalyzeDataseriesIds([]);
            }
        }
        
        if (gapAnalyzeDataseriesIds === null && gapAnalyzeId !== null && elementId !== null) {
            getData()
        }

    }, [gapAnalyzeId, elementId, revisionId, gapAnalyzeDataseriesIds, setGapAnalyzeDataseriesIds]);
}

const useGetGapAnalyzeMyActions = (gapAnalyzeId, elementsArray, setElementsList) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getGapAnalyzeMyActions(gapAnalyzeId);

                if (serviceResponse.data.succeeded) {
                    setElementsList && setElementsList(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: serviceResponse.data.data
                    }));
                }
                else {
                    setElementsList && setElementsList([]);
                }
            }
            catch (error) {
                setElementsList && setElementsList([]);
            }
        }
        
        if (gapAnalyzeId !== null && elementsArray.data === null) {
            getData()
        }

    }, [gapAnalyzeId, elementsArray, setElementsList]);
}

const useGetGapFull = (gapAnalyzeId, revisionId, revisionDataserieId, gapRevisionDataserieFullList, setGapRevisionDataserieFullList) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getGapFull(gapAnalyzeId, null, revisionId, revisionDataserieId);

                if (serviceResponse.data.succeeded) {
                    let result = serviceResponse.data;

                    setGapRevisionDataserieFullList && setGapRevisionDataserieFullList({
                        fireUpdateLastAction: true,
                        data: result.data
                    });
                }
                else {
                    setGapRevisionDataserieFullList && setGapRevisionDataserieFullList([])   
                }
            }
            catch (error) {
                setGapRevisionDataserieFullList && setGapRevisionDataserieFullList([])   
            }
        }
        
        if (gapAnalyzeId !== null && gapRevisionDataserieFullList === null) {
            getData()
        }

    }, [gapAnalyzeId, revisionId, revisionDataserieId, gapRevisionDataserieFullList, setGapRevisionDataserieFullList]);
}


const useGetGapAefFishbones_AND_RevisionDataserieFullList = (gapAnalyzeId, elementId, gapAnalyzeDataserieId, calendarSelector, setDataserieFullData, dataserieFullData) => {    
    useEffect(()=> {
        const getData = async () => {

            try {
                let serviceResponseRevisionDataserieFullList = await getGapFull(gapAnalyzeId, elementId, gapAnalyzeDataserieId === 0 ? null : gapAnalyzeDataserieId, calendarSelector.calendarSelectorId, calendarSelector.periodStartDate, calendarSelector.periodEndsDate);
                if (serviceResponseRevisionDataserieFullList.data.succeeded) {
                    let resultRevisionDataserieFullList = serviceResponseRevisionDataserieFullList.data;

                    try {
                        let serviceResponse = await getGapAefFishbones(gapAnalyzeId);
                        if (serviceResponse.data.succeeded) {
                            let result = serviceResponse.data;
                            let newFishboneList = []
        
                            resultRevisionDataserieFullList.data.forEach(revisionDataserie => {
                                let fishBoneToDataserie = result.data.find(x => x.gapAnalyzeDataserieId === revisionDataserie.id)
                                revisionDataserie.fishBone = fishBoneToDataserie !== undefined ? TransformToFishboneStructure([fishBoneToDataserie], true, revisionDataserie.gapValue)[0] : { objNew: null, gapAnalyzeDataserieId : null}
                                revisionDataserie.fishBone.gapAnalyzeDataserieId = revisionDataserie.id
                                newFishboneList.push(revisionDataserie.fishBone)
                                revisionDataserie.l_gap_aef_cause = []
        
                                fishBoneToDataserie !== undefined && revisionDataserie.l_causes.forEach(cause => {
                                    fishBoneToDataserie.l_gap_aef_category.forEach(category => {
                                        category.l_gap_aef_cause.forEach(_cause => {
                                            revisionDataserie.l_gap_aef_cause.push(_cause)
                                            if (_cause.id === cause.gapAefCauseId) {
                                                cause.name = _cause.name;
                                            }
                                        });
                                    });
                                });
                            });
        
                            resultRevisionDataserieFullList.data.forEach(revisionDataserie => {
                                let fishBoneToDataserie = result.data.find(x => x.gapAnalyzeDataserieId === revisionDataserie.id)
                                revisionDataserie.l_gap_aef_cause = []
                                fishBoneToDataserie !== undefined && fishBoneToDataserie.l_gap_aef_category.forEach(category => {
                                    category.l_gap_aef_cause.forEach(_cause => {
                                        revisionDataserie.l_gap_aef_cause.push(_cause)
                                    });
                                });
                            });
        
                            setDataserieFullData && setDataserieFullData({
                                fireUpdateLastAction: true,
                                revisionDataserieFullList: resultRevisionDataserieFullList.data,
                                gapFishboneList: newFishboneList
                            });
                        }
                        else {
                            setDataserieFullData && setDataserieFullData({
                                fireUpdateLastAction: false,
                                revisionDataserieFullList: [],
                                gapFishboneList: []
                            }); 
                        }
                    }
                    catch (error) {
                    }

                }
                else {
                    setDataserieFullData && setDataserieFullData({
                        fireUpdateLastAction: false,
                        revisionDataserieFullList: [],
                        gapFishboneList: []
                    });
                }
            }
            catch (error) {
                setDataserieFullData && setDataserieFullData({
                    fireUpdateLastAction: false,
                    revisionDataserieFullList: [],
                    gapFishboneList: []
                });
            }
        }
        
        if (gapAnalyzeId !== null && elementId !== null && calendarSelector !== null && dataserieFullData.revisionDataserieFullList === null && dataserieFullData.gapFishboneList === null) {
            getData()
        }

    }, [gapAnalyzeId, elementId, gapAnalyzeDataserieId, calendarSelector, setDataserieFullData, dataserieFullData]);
}


const useGetListGapCausesBoard = (gapAnalyzeId, elementId, dataserieValueId, causeList, setCauseList) => {    
    const dispatch = useDispatch();
    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListGapCausesBoard(gapAnalyzeId, elementId, dataserieValueId, 0);

                if (serviceResponse.data.succeeded) {
                    let result = serviceResponse.data;

                    setCauseList && setCauseList({
                        fireSearch: false,
                        data: result.data
                    })

                    dispatch(action_setGapCauses(result.data))
                }
                else {
                    setCauseList && setCauseList({
                        fireSearch: false,
                        data: null
                    })  

                    dispatch(action_setGapCauses(null))
                }
            }
            catch (error) {
                setCauseList && setCauseList({
                    fireSearch: false,
                    data: null
                })  
                dispatch(action_setGapCauses(null))
            }
        }
        
        if (gapAnalyzeId !== null && elementId !== null && dataserieValueId !== null && causeList.fireSearch === true) {
            getData()
        }

    }, [gapAnalyzeId, elementId, dataserieValueId, causeList, setCauseList]);
}

const useGetListGaps = (gapAnalyzeId, revisionId, elementId, revisionDataserieId, gapFullList, setGapFullList) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListGaps(gapAnalyzeId, elementId, revisionId, revisionDataserieId);

                if (serviceResponse.data.succeeded) {
                    let result = serviceResponse.data;

                    setGapFullList && setGapFullList(result.data)
                }
                else {
                    setGapFullList && setGapFullList([])   
                }
            }
            catch (error) {
            }
        }
        
        if (gapAnalyzeId !== null && gapFullList === null) {
            getData()
        }

    }, [gapAnalyzeId, revisionId, elementId, revisionDataserieId, gapFullList, setGapFullList]);
}

const useGetBasicRevisionInformation = (gapAnalyzeId, gapRevisionId, revisionBasicInformation, setRevisionBasicInformation, isPanelOpen, useCommonStructure, setAuxGapList, setAuxActionList) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getRevisionBasicInformation(gapAnalyzeId, gapRevisionId);

                if (serviceResponse.data.succeeded) {
                    let result = serviceResponse.data;

                    if (useCommonStructure) {
                        setRevisionBasicInformation && setRevisionBasicInformation({
                            id: result.data.gapRevisionId,
                            l_action_ids: result.data.l_actions.map(x => (x.id)),
                            l_gap_ids: result.data.l_gaps.map(x => (x.id)),

                            l_gaps: result.data.l_gaps.map(item => ({ ...item, checked: true })),

                            title: result.data.title,
                            statusId: result.data.statusId,
                            referenceDate: [moment(result.data.referenceDate).toDate().setHours(0, 0, 0, 0), moment(result.data.referenceDate).toDate().setHours(23, 59, 59, 999)],
                        })

                        setAuxGapList && setAuxGapList(result.data.l_gaps.map(item => ({ ...item, checked: true })));
                        setAuxActionList && setAuxActionList(result.data.l_actions.map(item => ({ ...item, checked: true })));
                    }
                    else {
                        setRevisionBasicInformation && setRevisionBasicInformation(result.data)
                    }
                }
                else {
                    setRevisionBasicInformation && setRevisionBasicInformation({})   
                }
            }
            catch (error) {
                setRevisionBasicInformation && setRevisionBasicInformation({})   
            }
        }
        
        if (gapAnalyzeId !== null && (setAuxGapList !== undefined && setAuxActionList !== undefined) && gapRevisionId !== null && (revisionBasicInformation === null || revisionBasicInformation.id === null) && isPanelOpen === true) {
            getData()
        }

    }, [gapAnalyzeId, gapRevisionId, revisionBasicInformation, setRevisionBasicInformation, isPanelOpen, setAuxGapList, setAuxActionList]);
}

const useGetListGapAnalyzeComments = (gapAnalyzeId, revisionId, gapId, gapActionId, dataserieValueId, fromGapSection, comments, setComments, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListGapAnalyzeComments(gapAnalyzeId, revisionId, gapId, gapActionId, fromGapSection, dataserieValueId);

                if (serviceResponse.data.succeeded) {
                    if (fromGapSection === __GapEventTypes.GAP_REVISION_COMMENTS || fromGapSection === __GapEventTypes.GAP_DATASERIEVALUE_COMMENTS) {
                        setComments && setComments(prevState => ({
                            ...prevState,
                            fireUpdate: true,
                            data: serviceResponse.data.data
                        }));
                    }
                    else {
                        setComments && setComments(serviceResponse.data.data);
                    }
                }
                else {
                    if (fromGapSection === __GapEventTypes.GAP_REVISION_COMMENTS || fromGapSection === __GapEventTypes.GAP_DATASERIEVALUE_COMMENTS) {
                        setComments && setComments(prevState => ({
                            ...prevState,
                            fireUpdate: true,
                            data: []
                        }));
                    }
                    else {
                        setComments && setComments([]);
                    }
                }
            }
            catch (error) {
                setComments && setComments([]);
            }
        }
        
        if (gapAnalyzeId !== null && ((fromGapSection === __GapEventTypes.GAP_REVISION_COMMENTS || fromGapSection === __GapEventTypes.GAP_DATASERIEVALUE_COMMENTS) ? (comments.data === null) : (comments === null)) && isPanelOpen === true) {
            getData()
        }

    }, [gapAnalyzeId, revisionId, gapId, gapActionId, dataserieValueId, fromGapSection, comments, setComments, isPanelOpen]);
}

const useGetListGapActions = (gapAnalyzeId, elementId, gapRevisionId, gapId, dataserieValueId, gapCauseId, gapActionFromRevisionId, actionList, setActionist, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListGapActions(gapAnalyzeId, elementId, gapRevisionId, gapId, dataserieValueId, gapCauseId, gapActionFromRevisionId);

                setActionist && setActionist(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: serviceResponse.data.data
                }));
            }
            catch (error) {
                setActionist && setActionist(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: []
                }));
            }
        }
        
        if (gapAnalyzeId !== null && actionList.data === null && isPanelOpen === true) {
            getData()
        }

    }, [gapAnalyzeId, elementId, gapRevisionId, gapId, dataserieValueId, gapCauseId, gapActionFromRevisionId, actionList, setActionist, isPanelOpen]);
}

const useGetListLastEvents = (gapAnalyzeId, gapRevisionId, iPage, iTake, eventList, setEventList, setITake, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListLastEvents(gapAnalyzeId, gapRevisionId, null, null, null, null, iPage, iTake);

                setEventList && setEventList(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: serviceResponse.data.data
                }));

                setITake && setITake(iTake + 10)
            }
            catch (error) {
                setEventList && setEventList(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: []
                }));
            }
        }
        
        if (gapAnalyzeId !== null && eventList.data === null && isPanelOpen) {
            getData()
        }

    }, [gapAnalyzeId, gapRevisionId, iPage, iTake, eventList, setEventList, setITake, isPanelOpen]);
}
const useGetListLastActions = (gapAnalyzeId, actionList, setActionFiltredList, setITake, needFire, setNeedFire) => {    
    const dispatch = useDispatch();
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListLastActions(gapAnalyzeId);

                if (serviceResponse.data.succeeded) {
                    setActionFiltredList && setActionFiltredList(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: serviceResponse.data.data
                    }));

                    dispatch(action_setGapActions({
                        pageNumber: 1,
                        pageSize: 10,
                        filters: [],
                        fireUpdate: true,
                        data: serviceResponse.data.data
                    }))

                    //setITake && setITake(iTake + 10)
                }
                else {
                    setActionFiltredList && setActionFiltredList(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: []
                    }));

                    dispatch(action_setGapActions({
                        pageNumber: 1,
                        pageSize: 10,
                        filters: [],
                        fireUpdate: true,
                        data: []
                    }))
                }
                
                setNeedFire && setNeedFire(false)
            }
            catch (error) {
                setActionFiltredList && setActionFiltredList(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: []
                }));

                dispatch(action_setGapActions({
                    pageNumber: 1,
                    pageSize: 10,
                    filters: [],
                    fireUpdate: true,
                    data: []
                }))

                setNeedFire && setNeedFire(false)
            }
        }
        
        if (gapAnalyzeId !== null && (actionList.data === null || needFire === true)) {
            getData()
        }

    }, [gapAnalyzeId, actionList, setActionFiltredList, setITake, needFire, setNeedFire]);
}

const useGetListLastEventsHome = (iPage, iTake, eventList, setEventList, setITake, isPanelOpen, fireSearch, setFireSearch) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListLastEventsHome(iPage, iTake);

                if (serviceResponse.data.succeeded) {

                    setFireSearch && setFireSearch(false)

                    setEventList && setEventList(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: serviceResponse.data.data
                    }));

                    setITake && setITake(iTake + 10)
                }
                else {
                    setFireSearch && setFireSearch(false)

                    setEventList && setEventList(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: []
                    }));
                }
            }
            catch (error) {
                setFireSearch && setFireSearch(false)
                setEventList && setEventList(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: []
                }));
            }
        }
        
        if ((eventList.data === null || fireSearch) && isPanelOpen) {
            getData()
        }

    }, [iPage, iTake, eventList, setEventList, setITake, isPanelOpen, fireSearch, setFireSearch]);
}
const useGetListLastActionsHome = (iPage, iTake, actionList, setActionList, setITake, fireSearch, setFireSearch) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListLastActionsHome(iPage, iTake);

                if (serviceResponse.data.succeeded) {

                    setFireSearch && setFireSearch(false)

                    setActionList && setActionList(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: serviceResponse.data.data
                    }));
    
                    setITake && setITake(iTake + 10)
                }
                else {
                    setFireSearch && setFireSearch(false)

                    setActionList && setActionList(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: []
                    }));
                }
            }
            catch (error) {
                setFireSearch && setFireSearch(false)
                setActionList && setActionList(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: []
                }));
            }
        }
        
        if (actionList.data === null || fireSearch === true) {
            getData()
        }

    }, [iPage, iTake, actionList, setActionList, setITake, fireSearch, setFireSearch]);
}


const useGetListGapRevisionDocuments = (gapRevisionId, documentList, setDocumentLinkList, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListGapRevisionDocuments(gapRevisionId);

                if (serviceResponse.data.succeeded === true) {
                    const response = serviceResponse.data.data;
                    setDocumentLinkList(response);
                }
                else {
                    setDocumentLinkList([]);
                }
            }
            catch (error) {
                setDocumentLinkList([]);
            }
        }
        
        if (gapRevisionId !== null && documentList === null && isPanelOpen === true) {
            getData()
        }
    }, [gapRevisionId, documentList, setDocumentLinkList, isPanelOpen]);
}

const useGetListGapActionDocuments = (gapActionId, documentList, setDocumentLinkList, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListGapActionDocuments(gapActionId);

                if (serviceResponse.data.succeeded === true) {
                    const response = serviceResponse.data.data;
                    setDocumentLinkList(response);
                }
                else {
                    setDocumentLinkList([]);
                }
            }
            catch (error) {
                setDocumentLinkList([]);
            }
        }
        
        if (gapActionId !== null && documentList === null && isPanelOpen === true) {
            getData()
        }
    }, [gapActionId, documentList, setDocumentLinkList, isPanelOpen]);
}

const useOfGetPossibleGaps = (element, gapAnalyzeId, boardId, dataserieList, setDataserieList, setRevisionList, setGapAnalyzeList, setPosibleGapsConfig, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getPossibleGaps(element.elementId, gapAnalyzeId, boardId);

                if (serviceResponse.data.succeeded === true) {
                    const response = serviceResponse.data.data;
                    //setDataserieList(response)

                    let dataseries = [];
                    response.l_possiblegaps.forEach(possibleGap => {

                        possibleGap.l_dataserie_values.forEach(dataserieValue => {
                            if (!dataserieValue.hasGAP) {
                                dataseries.push({
                                    key: possibleGap.id,
                                    id: dataserieValue.id,
                                    dataserieId: possibleGap.id,
                                    name: possibleGap.name,
                                    um: possibleGap.um,
                                    elementId: possibleGap.elementId,
    
                                    displayValue: dataserieValue.displayValue,
                                    serieTime: dataserieValue.serieTime,
                                    valueGoal: dataserieValue.valueGoal,
                                    valueGoalPercent: dataserieValue.valueGoalPercent,
        
                                    revisionList: [],
                                })
                            }
                        });
                    });
                    
                    setDataserieList && setDataserieList(dataseries);
                    setGapAnalyzeList && setGapAnalyzeList(response.l_gapanalyze);
                    
                    setPosibleGapsConfig && setPosibleGapsConfig({
                        eDataserieWithOutGapRevision : response.eDataserieWithOutGapRevision,
                        eGapAnalyzeElement : response.eGapAnalyzeElement,//Es para cuando el elemento no esta ligado a un gap analyze
                        eGaps : response.eGaps,
                        eGapsWithOutGap : response.eGapsWithOutGap//Es para cuando no hay dataserievalues que porocesar.
                    })

                    if (response.l_gapanalyze.length > 0) {
                        let serviceResponseRevisions = await getGapRevisionsList(response.l_gapanalyze[0].id);

                        if (serviceResponseRevisions.data.succeeded === true) {
                            const responseRevisions = serviceResponseRevisions.data.data;
                            let revisions = [];
                            responseRevisions.forEach(revision => {
                                revisions.push({
                                    key: revision.id,
                                    id: revision.id,
                                    //name: revision.title,
                                    periodId: revision.periodId,
                                    referenceDate: revision.referenceDate,
                                    name: revision.referenceDate !== null ? moment(revision.referenceDate).format('YYYY/MM/DD') : 'Rev',
                                    gapAnalyzeId: revision.gapAnalyzeId,
                                    //date: gapAnalyze.referenceDate,
                                    //period: gapAnalyze.periodId,
                                    l_element_id: response.l_gapanalyze.find( x => x.id === revision.gapAnalyzeId).l_element_id,
                                    statusId: response.l_gapanalyze.find( x => x.id === revision.gapAnalyzeId).statusId,
        
                                    dataserieList: [],
                                })
                            });
                            
                            setRevisionList && setRevisionList(revisions)
                        }
                        else {
                            setRevisionList && setRevisionList([]);
                        }
                    }
                    else {
                        setRevisionList && setRevisionList([]);
                    }
                }
                else {
                    setDataserieList && setDataserieList([]);
                    setGapAnalyzeList && setGapAnalyzeList([]);
                }
            }
            catch (error) {
                setDataserieList && setDataserieList([]);
            }
        }
        
        if (element !== null && (gapAnalyzeId !== null || boardId !== null) && dataserieList === null && isPanelOpen === true) {
            getData()
        }
    }, [element, gapAnalyzeId, boardId, dataserieList, setDataserieList, setRevisionList, setGapAnalyzeList, setPosibleGapsConfig, isPanelOpen]);
}

const useGetGapDataseriePossiblesGaps = (elementId, gapAnalyzeId, dataserieList, setDataserieList, setGapAnalyzeList, setPosibleGapsConfig, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getGapDataseriePossiblesGaps(elementId, gapAnalyzeId, null);

                if (serviceResponse.data.succeeded === true) {
                    const response = serviceResponse.data.data;

                    let dataseries = [];
                    response.l_possiblegaps.forEach(possibleGap => {
                        let gapAnalyzeId = null;

                        response.l_gapanalyze.forEach(gapAnalyze => {
                            if (gapAnalyze.l_element_id.find(x => x === possibleGap.elementId) !== undefined) {
                                gapAnalyzeId = gapAnalyze.id;
                            }
                        });

                        if (possibleGap.hasGaps) {
                            dataseries.push({
                                key: possibleGap.id,
                                id: possibleGap.id,
                                dataserieId: possibleGap.id,
                                name: possibleGap.name,
                                um: possibleGap.um,
                                elementId: possibleGap.elementId,
                                hasGapAnalyzeDataserie: possibleGap.hasGapAnalyzeDataserie,
                                hasGaps: possibleGap.hasGaps,
                                revisionList: [],
                                gapAnalyzeId: gapAnalyzeId
                            })
                        }
                    });
                    
                    setDataserieList && setDataserieList(dataseries);
                    setGapAnalyzeList && setGapAnalyzeList(response.l_gapanalyze);
                    
                    setPosibleGapsConfig && setPosibleGapsConfig({
                        eDataserieWithOutGapRevision : response.eDataserieWithOutGapRevision,
                        eGapAnalyzeElement : response.eGapAnalyzeElement,//Es para cuando el elemento no esta ligado a un gap analyze
                        eGaps : response.eGaps,
                        eGapsWithOutGap : response.eGapsWithOutGap//Es para cuando no hay dataserievalues que porocesar.
                    })
                }
                else {
                    setDataserieList && setDataserieList([]);
                    setGapAnalyzeList && setGapAnalyzeList([]);
                }
            }
            catch (error) {
                setDataserieList && setDataserieList([]);
            }
        }
        
        if (elementId !== null && (gapAnalyzeId !== null) && dataserieList === null && isPanelOpen === true) {
            getData()
        }
    }, [elementId, gapAnalyzeId, dataserieList, setDataserieList, setGapAnalyzeList, setPosibleGapsConfig, isPanelOpen]);
}

const useOfGetRevisions = (gapAnalyzeId, revisionList, setRevisionList, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getGapRevisionsList(gapAnalyzeId);

                if (serviceResponse.data.succeeded === true) {
                    const response = serviceResponse.data.data;
                    //setRevisionList(response)

                    let dataseries = [];

                    response.forEach(item => {
                        dataseries.push({
                            id: item.id,
                            name: item.gapAnalyzeId,
                            date: item.referenceDate,
                            period: item.periodId,
                            statusId: item.statusId,
    
                            dataserieList: [],
                        })
                    });
                    
                    setRevisionList(dataseries);
                }
                else {
                    setRevisionList([]);
                }
            }
            catch (error) {
                setRevisionList([]);
            }
        }
        
        if (gapAnalyzeId !== null && revisionList === null && isPanelOpen === true) {
            getData()
        }
    }, [gapAnalyzeId, revisionList, setRevisionList, isPanelOpen]);
}

const useGetListGapActionEvents = (gapAnalyzeId, gapActionId, actionEventList, setActionEventList, isPanelOpen, page, take) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListLastEvents(gapAnalyzeId, null, null, null, null, gapActionId, page, take);

                if (serviceResponse.data.succeeded) {
                    let result = serviceResponse.data;
                    setActionEventList && setActionEventList(result.data);
                }
                else {
                    setActionEventList && setActionEventList([]);
                }
            }
            catch (error) {
                setActionEventList && setActionEventList([]); 
            }
        }
        
        if (actionEventList === null && gapAnalyzeId !== null && gapActionId !== null && isPanelOpen === true) {
            getData()
        }

    }, [gapAnalyzeId, gapActionId, actionEventList, setActionEventList, isPanelOpen]);
}


const useGetListGapActionComments = (gapAnalyzeId, gapActionId, actionCommentList, setActionCommentList, isPanelOpen, iPage, iTake) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                //[##PROBAR##]
                let serviceResponse = await getListGapAnalyzeComments(gapAnalyzeId, null, null, gapActionId, __GapEventTypes.GAP_ACTION, null);

                if (serviceResponse.data.succeeded) {
                    let result = serviceResponse.data;
                    setActionCommentList && setActionCommentList(result.data);
                }
                else {
                    setActionCommentList && setActionCommentList([]);
                }
            }
            catch (error) {
                setActionCommentList && setActionCommentList([]); 
            }
        }
        
        if (actionCommentList === null && gapAnalyzeId !== null && gapActionId !== null && isPanelOpen === true) {
            getData()
        }

    }, [gapAnalyzeId, gapActionId, actionCommentList, setActionCommentList, isPanelOpen]);
}


export {
    useGetHomeGapStadistic,
    useGetGAPById,
    useGetCreateGapAnalyzeProcessByElementId,
    useGetGAPElementsByGAPId,
    useGetListGapAnalyzeDataseriesIds,
    useGetFishboneTemplateList,
    useGetGapRevisionDatareieList,
    useGetGapRevisionsList,
    useGetGapRevisionPossibleGaps,
    useGetGapRevionListPossibleActions,
    useGetGapFull,
    useGetListGaps,
    useGetBasicRevisionInformation,
    useGetListGapAnalyzeComments,
    useGetGapAefFishbones_AND_RevisionDataserieFullList,
    useGetListGapCausesBoard,
    useGetListGapActions,
    useGetListLastEvents,
    useGetListLastEventsHome,
    useGetListLastActions,
    useGetListLastActionsHome,
    useGetListGapRevisionDocuments,
    useGetListGapActionDocuments,
    useGetGapAnalyzeMyActions,
    useOfGetPossibleGaps,
    useGetGapDataseriePossiblesGaps,
    useOfGetRevisions,
    useGetListGapActionEvents,
    useGetListGapActionComments
}